module.exports = __webpack_public_path__ + "img/logo.58c36f5c.svg";